var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { darken } from 'polished';
import React from 'react';
import { css, styled } from "../utils";
var StyledTextLink = styled.a(function (_a) {
    var align = _a.align, _b = _a.theme, colors = _b.colors, fonts = _b.fonts, fontWeights = _b.fontWeights;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      text-align: ", ";\n      color: ", ";\n      font-family: ", ";\n      display: block;\n      font-weight: ", ";\n      margin: 0.5rem 0;\n      line-height: 1.5;\n      text-decoration: underline;\n\n      &:hover {\n        cursor: pointer;\n      }\n\n      &:hover,\n      &:active,\n      &:focus {\n        color: ", ";\n      }\n    "], ["\n      text-align: ", ";\n      color: ", ";\n      font-family: ", ";\n      display: block;\n      font-weight: ", ";\n      margin: 0.5rem 0;\n      line-height: 1.5;\n      text-decoration: underline;\n\n      &:hover {\n        cursor: pointer;\n      }\n\n      &:hover,\n      &:active,\n      &:focus {\n        color: ", ";\n      }\n    "])), align, colors.primary, fonts.primary, fontWeights.medium, darken(0.05, colors.primary));
});
StyledTextLink.defaultProps = {
    align: 'left',
};
var TextLink = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(StyledTextLink, __assign({ "data-component": "TextLink" }, props), children));
};
export default TextLink;
var templateObject_1;
//# sourceMappingURL=TextLink.js.map